import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import ReactPlayer from 'react-player'

import { createPortalContainer } from 'utils/createPortalContainer'

interface VideoModalProps {
  url: string
  isOpen: boolean
  onClose: () => void
  showControls?: boolean
}

export const VideoModal: React.FC<VideoModalProps> = ({ url, isOpen, onClose, showControls = true }) => {
  const [container] = React.useState(createPortalContainer)

  useEffect(() => {
    document.body.appendChild(container)
    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto'
  }, [isOpen])

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/90 flex justify-center items-center z-[9999]"
      onClick={onClose} // close on overlay click
    >
      <div
        className="relative w-[90%] h-[90%]"
        // style={{ position: "relative", width: "90%", height: "80%" }}
        onClick={e => e.stopPropagation()} // prevent closing when clicking video
      >
        <button
          onClick={onClose}
          className="absolute top-2.5 right-3.5 text-2xl text-white bg-transparent border-0 cursor-pointer z-10"
        >
          ✕
        </button>

        <ReactPlayer
          url={url} // v2 uses `url`
          playing
          controls={showControls}
          width="100%"
          height="100%"
        />
      </div>
    </div>,
    container,
  )
}
